export default [
  {
    value: "",
    text: "Select Your Faculty"
  },
  { value: "Arts", text: "Arts" },
  { value: "Basic Medical Sciences", text: "Basic Medical Sciences" },
  { value: "Business Administration", text: "Business Administration" },
  { value: "Clinical Sciences", text: "Clinical Sciences" },
  { value: "Dental Sciences", text: "Dental Sciences" },
  { value: "Education", text: "Education" },
  { value: "Engineering", text: "Engineering" },
  { value: "Environmental Science", text: "Environmental Science" },
  { value: "Law", text: "Law" },
  { value: "Pharmacy", text: "Pharmacy" },
  { value: "Science", text: "Science" },
  { value: "Social Sciences", text: "Social Sciences" }
];
